import React from 'react';
import { Box, FormControl, FormHelperText, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { useAtom, useAtomValue, WritableAtom } from 'jotai';
import { errorAtom } from 'atoms/error';
import { authTokenAtom } from 'atoms/authAtoms';
import { usePhases } from 'utils/hooks/useRToolTree';
import { useAutoSelectSingle } from 'utils/hooks/useAutoSelectSingle';
import { Config } from 'atoms/Rtool/newConfigAtoms';

type Props = {
    atom: WritableAtom<string, [newProjectId: string], void>;
    config: Config;
};

export const PhaseSelect: React.FC<Props> = ({ atom, config }) => {
    const authToken = useAtomValue(authTokenAtom);
    const [phaseId, setphaseId] = useAtom(atom);
    const [error] = useAtom(errorAtom);
    const { items: phases, loading } = usePhases(authToken, config);
    // 選択肢が1件のみの段は自動選択し、一意に定まる限り下位へ連鎖させる
    useAutoSelectSingle(phases, loading, phaseId, setphaseId);

    return (
        <Box sx={{ flex: '1 1 calc(50% - 16px)' }}>
            <FormControl fullWidth disabled={!config.lot_id || loading} error={Boolean(error)}>
                <InputLabel id="phase-select-label">Phase</InputLabel>
                <Select
                    labelId="phase-select-label"
                    value={phaseId}
                    label="phase"
                    onChange={(e) => setphaseId(e.target.value as string)}
                >
                    <MenuItem value="">
                        <em>None</em>
                    </MenuItem>
                    {phases.map((phase) => (
                        <MenuItem key={phase} value={phase}>
                            {phase}
                        </MenuItem>
                    ))}
                </Select>
                {error && <FormHelperText>{error}</FormHelperText>}
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{ position: 'absolute', top: '50%', right: 16, mt: '-12px' }}
                    />
                )}
            </FormControl>
        </Box>
    );
};
